module.exports = __webpack_public_path__ + "img/EKO.5e3721c7.svg";